import { Component, OnInit, Input } from '@angular/core';
import { ModalController} from '@ionic/angular';
import { ContactsImportPage } from '../contacts-import/contacts-import.page';

import { Capacitor } from '@capacitor/core';

import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";

import { Contact } from '../models/contact';
import { Property } from '../models/property';
import { ApiService } from '../services/api.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-property-add',
  templateUrl: './property-add.component.html',
  styleUrls: ['./property-add.component.scss'],
})
export class PropertyAddComponent implements OnInit {

  @Input() public contactId: number;
  @Input() public existingProperty: Property;
  isNativePlatform = true;
  ionicForm: UntypedFormGroup;
  isSubmitted = false;

  constructor(public modalCtrl: ModalController, public formBuilder: UntypedFormBuilder, public apiService: ApiService, public router: Router) { }

  ngOnInit() {
    this.isNativePlatform = Capacitor.isNativePlatform();

    // Build Contact Form
    this.ionicForm = this.formBuilder.group({
      address1: [''],
      address2: [''],
      city: [''],
      postcode: ['']
    })

    // If we have an existing property, update the form with the existing property details
    if (this.existingProperty) {
      this.ionicForm.patchValue({
        address1: this.existingProperty.address1,
        address2: this.existingProperty.address2,
        city: this.existingProperty.city,
        postcode: this.existingProperty.postcode
      });
    }
  }

  dismiss() {  
    this.modalCtrl.dismiss();
  }

  private prepareSave(): Property {
    var newProperty = new Property().deserialize(this.ionicForm.value);
    newProperty.contactId = this.contactId;
    
    return newProperty;
  }

  submitForm() {
    this.isSubmitted = true;

    if (!this.ionicForm.valid) {
      console.log('Please provide all the required values for a contact.')
      console.log(this.ionicForm);
      return false;
    } else {
      console.log(this.ionicForm.value)

      // Save contact information
      const newProperty = this.prepareSave(); // `newProperty` is now an instance of "Property"

      // API Call
      this.apiService.createProperty(newProperty).subscribe((property) => {
        // Close the modal
        this.modalCtrl.dismiss(property);
      });
      
    }
  }

  get errorControl() {
    return this.ionicForm.controls;
  }


}